/// <reference path="../_all.ts" />

module library {
  'use strict';

  export function MinsSecFilter() {
    return function (sec, precision) {
      if (isNaN(parseFloat(sec)) || !isFinite(sec)) return '-';
      if (typeof precision === 'undefined') precision = 1;
      if (sec < 1) return sec.toFixed(precision) + ' s';
      var units = ['sec', 'min'],
        number = Math.floor(Math.log(sec) / Math.log(60));
      return (sec / Math.pow(60, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    }
  }
}